import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';
import { defaultBorrowerLegalName } from '../../../../../../../components/loan_application/form_models/constants';
import SystemPropertyHasRelatedTenantsRuleset from '../../business/ruleset/SystemPropertyHasRelatedTenantsRuleset';

const { systemPropertyHasRelatedTenants } = loanFormModel.formField;

export class SystemPropertyHasRelatedTenantsValidation
  implements ValidationSchema
{
  public name = systemPropertyHasRelatedTenants.name;
  public label = systemPropertyHasRelatedTenants.getLabel(
    defaultBorrowerLegalName,
    ''
  );
  public type = 'string';

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;
  public ruleset = SystemPropertyHasRelatedTenantsRuleset;

  public when(schema: Yup.StringSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(new SystemPropertyHasRelatedTenantsValidation());
